import React, { useState } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  TextField,
  Button,
  IconButton,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BitgoCustAccount = ({ open, setopen }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    dob: "",
    ssn: "",
  });

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    const {
      firstName,
      lastName,
      email,
      phone,
      address,
      city,
      state,
      country,
      zipcode,
      dob,
      ssn,
    } = formData;

    const dataToSend = `
      First Name: ${firstName}
      Last Name: ${lastName}
      Email: ${email}
      Phone No: ${phone}
      Address: ${address}
      City: ${city}
      State: ${state}
      Country: ${country}
      ZipCode: ${zipcode}
      Date Of Birth: ${dob}
      Social Security: ${ssn}
    `;
  };

  const handleClose = () => {
    setopen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={open}>
        <Box
          className="modal-content"
          sx={{
            maxWidth: "60%",
            maxHeight: "60%",
            width: "90%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            overflow: "auto",
          }}
        >
          <div className="modal-header">
            <Grid container alignItems="center" justifyContent="space-between">
              <Typography variant="h6">Create Custodian Client</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </div>
          <div
            className="modal-body"
            style={{ marginTop: "10px", width: "100%" }}
          >
            <TextField
              label="First Name"
              size="small"
              value={formData.firstName}
              onChange={(e) => handleInputChange("firstName", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Last Name"
              size="small"
              value={formData.lastName}
              onChange={(e) => handleInputChange("lastName", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Email"
              size="small"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Phone No"
              size="small"
              value={formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Address"
              size="small"
              value={formData.address}
              onChange={(e) => handleInputChange("address", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="City"
              size="small"
              value={formData.city}
              onChange={(e) => handleInputChange("city", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="State"
              size="small"
              value={formData.state}
              onChange={(e) => handleInputChange("state", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Country"
              size="small"
              value={formData.country}
              onChange={(e) => handleInputChange("country", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="ZipCode"
              size="small"
              value={formData.zipcode}
              onChange={(e) => handleInputChange("zipcode", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Date Of Birth"
              size="small"
              value={formData.dob}
              onChange={(e) => handleInputChange("dob", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Social Security"
              size="small"
              value={formData.ssn}
              onChange={(e) => handleInputChange("ssn", e.target.value)}
              fullWidth
              margin="dense"
              sx={{ marginBottom: "10px" }}
            />
          </div>
          <div className="modal-footer" style={{ marginTop: "20px" }}>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Submit
            </Button>
            <Button onClick={handleClose} variant="outlined" color="primary">
              Cancel
            </Button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default BitgoCustAccount;
